import React, { useState } from "react";
import "../components/Factoring.css";
import factura from "../assets/img/FACTURA.gif";
import contrato from "../assets/img/CONTRATO.gif";
import letra from "../assets/img/LETRA.gif";
import contratacion from "../assets/img/contratacionsmallWeb.png";
import videoWebIcons from "../assets/img/videoWebIconos.gif";
import FormularioWeb from "../components/FormularioWeb";
import Footer from "../components/Footer";
import Beneficios from "../assets/img/PCP_Mesadetrabajo1.png";
import Requisitos from "../assets/img/requisitossmallWeb.png";
import RequisitosImg from "../assets/img/factoringv2movil.jpg";

const Factoring = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [subActiveIndex, setSubActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const toggleSubAccordion = (index) => {
    setSubActiveIndex(subActiveIndex === index ? null : index);
  };

  return (
    <div>
      <div className="bannerFactoring">
        <h1 className="bannerFactoring-title">Factoring</h1>
      </div>
      <div className="containerBannerFactoring">
        <p className="textoBannerFactoring">
          Transforma tus cuentas por cobrar en dinero efectivo.
        </p>
      </div>
      <div className="main-containerFactoring">
        <div className="inner-containerFactoring">
          <div className="itemFactoring">
            <img src={factura} alt="Facturas" />
            <h2>Facturas</h2>
          </div>
          <div className="itemFactoring">
            <img src={contrato} alt="Contratos" />
            <h2>Recibo por Honorarios</h2>
          </div>
          <div className="itemFactoring">
            <img src={letra} alt="Letras" /> <h2>Letras</h2>
          </div>
        </div>
      </div>
      {/* ---------------ACCORDION------------ */}
      <div className="accordionFactoring">
        <div className="accordion-itemFactoring">
          <div
            className="accordion-titleFactoring"
            onClick={() => toggleAccordion(0)}
          >
            <img src={contratacion} alt="Contratación del Factoring" />
            <span
              style={{
                fontSize: "30px",
                color: "rgb(22, 44, 118)",
                marginLeft: "1em",
              }}
            >
              Contratación del factoring
            </span>
            <i
              className={`fas ${
                activeIndex === 0 ? "fa-angle-up" : "fa-angle-down"
              }`}
              style={{ marginLeft: "auto" }}
            ></i>
          </div>
          {activeIndex === 0 && (
            <div className="accordion-contentFactoring">
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "32px",
                  fontWeight: "bold",
                }}
              >
                Pasos a seguir
              </h2>
              <div className="video-containerFactoring">
                <img src={videoWebIcons} autoPlay muted loop alt="Describe pasos para Factoring"/>
              </div>
            </div>
          )}
        </div>
        <div className="accordion-itemFactoring">
          <div
            className="accordion-titleFactoring"
            onClick={() => toggleAccordion(1)}
          >
            <img
              src={Beneficios}
              className="beneficios"
              alt="Contratación del Factoring"
            />
            <span
              style={{
                fontSize: "30px",
                color: "rgb(22, 44, 118)",
                marginLeft: "1em",
              }}
            >
              Beneficios del Factoring
            </span>
            <i
              className={`fas ${
                activeIndex === 1 ? "fa-angle-up" : "fa-angle-down"
              }`}
              style={{ marginLeft: "auto" }}
            ></i>
          </div>
          {activeIndex === 1 && (
            <div className="accordion-contentFactoring">
              <ul>
                <li>
                  Obtén un mejor posicionamiento frente a tu competencia y
                  mejora tu capacidad financiera con la ayuda del Factoring. No
                  esperes más por los plazos para cancelar el pago de tus
                  facturas.
                </li>
                <li>Obtén dinero inmediato y mejora tu flujo de caja.</li>
                <li>
                  Mejora la relación con tus proveedores y terceriza la gestión
                  de cobranza.
                </li>
                <li>
                  El factoring desempeña un papel significativo en el fomento
                  del crecimiento empresarial. Numerosas pymes recurren a esta
                  forma de financiamiento como un peldaño inicial,
                  permitiéndoles posteriormente acceder a operaciones
                  crediticias más amplias.
                </li>                
              </ul>
            </div>
          )}
        </div>
        <div className="accordion-itemFactoring">
          <div
            className="accordion-titleFactoring"
            onClick={() => toggleAccordion(2)}
          >
            <img src={Requisitos} alt="Contratación del Factoring" />
            <span
              style={{
                fontSize: "30px",
                color: "rgb(22, 44, 118)",
                marginLeft: "1em",
              }}
            >
              Requisitos
            </span>
            <i
              className={`fas ${
                activeIndex === 2 ? "fa-angle-up" : "fa-angle-down"
              }`}
              style={{ marginLeft: "auto" }}
            ></i>
          </div>
          {activeIndex === 2 && (
            <div className="accordion-contentFactoring">
              <div className="requirementsFactoring">
                <div>
                  <img src={RequisitosImg} alt="Requisitos" />
                </div>

                <div>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginBottom: "1em"
                    }}
                  >
                    Requisitos para operar
                  </h3>
                  <p>
                  Afiliación al factoring en Primus Capital:
                  </p>
                  <div className="sub-accordionFactoring">
                    <div
                      className="accordion-itemFactoring"
                      style={{ width: "100%" }}
                    >
                      <div
                        className="accordion-titleFactoring"
                        onClick={() => toggleSubAccordion(3)}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "rgb(33, 64, 129)",
                          }}
                        >
                          Información comercial
                        </span>
                        <i
                          className={`fas ${
                            subActiveIndex === 3
                              ? "fa-angle-up"
                              : "fa-angle-down"
                          }`}
                          style={{ marginLeft: "auto" }}
                        ></i>
                      </div>
                      {subActiveIndex === 3 && (
                        <div className="accordion-contentFactoring">
                          <ul>
                            <li>Facturas, XML</li>
                          </ul>
                          
                        </div>
                      )}
                    </div>
                    <div
                      className="accordion-itemFactoring"
                      style={{ width: "100%" }}
                    >
                      <div
                        className="accordion-titleFactoring"
                        onClick={() => toggleSubAccordion(4)}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "rgb(33, 64, 129)",
                          }}
                        >
                          Información legal
                        </span>
                        <i
                          className={`fas ${
                            subActiveIndex === 4
                              ? "fa-angle-up"
                              : "fa-angle-down"
                          }`}
                          style={{ marginLeft: "auto" }}
                        ></i>
                      </div>
                      {subActiveIndex === 4 && (
                        <div className="accordion-contentFactoring">
                          <ul>
                            <li>
                            Vigencia de poder o Copia literal de la empresa, con antigüedad no mayor a 1 mes de emitida.
                            </li>
                          </ul>
                          <ul>
                            <li>
                            DNI del representante legal y su cónyuge en caso esté casado(a).
                            </li>
                          </ul>
                          <ul>
                            <li>
                            Ficha RUC de la Empresa.
                            </li>
                          </ul>
                         
                        </div>
                      )}
                    </div>
                    <div
                      className="accordion-itemFactoring"
                      style={{ width: "100%" }}
                    >
                      <div
                        className="accordion-titleFactoring"
                        onClick={() => toggleSubAccordion(5)}
                      >
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "bold",
                            color: "rgb(33, 64, 129)",
                          }}
                        >
                          Información financiera
                        </span>
                        <i
                          className={`fas ${
                            subActiveIndex === 5
                              ? "fa-angle-up"
                              : "fa-angle-down"
                          }`}
                          style={{ marginLeft: "auto" }}
                        ></i>
                      </div>
                      {subActiveIndex === 5 && (
                        <div className="accordion-contentFactoring">
                          <ul>
                            <li>Declaración jurada.</li>
                          </ul>
                          <ul>
                            <li>Reporte Tributario para Terceros (actualizado).</li>
                          </ul>
                          <ul>
                            <li>Brochure y/o carta de presentación de la empresa.</li>
                            
                          </ul>
                          <ul>
                            <li>Cuenta corriente donde desea recibir el abono.</li>
                            
                          </ul>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="formulario">
        <h2>¿Tienes facturas pendientes de cobro?</h2>
        <FormularioWeb />
      </div>
      <Footer />
    </div>
  );
};

export default Factoring;
